function passwordStrengthRules(password, compare = '') {
  const rules = {
    minLength: true,
    ucCharacter: true,
    lcCharacter: true,
    number: true,
    spCharacter: true,
    different: true,
    valid: true,
  };

  // Minimum of 8 Characters
  if (password.length < 8) {
    rules.minLength = false;
    rules.valid = false;
  }

  // Minimum of 1 Uppercase Letter
  if (/[A-Z]/.test(password) === false) {
    rules.ucCharacter = false;
    rules.valid = false;
  }

  // Minimum of 1 Lowercase Letter
  if (/[a-z]/.test(password) === false) {
    rules.lcCharacter = false;
    rules.valid = false;
  }

  // Minimum of 1 Number
  if (/\d/.test(password) === false) {
    rules.number = false;
    rules.valid = false;
  }

  // Minimum of 1 Special Character
  if (/[!@#$%^&*(),.?":{}|<>]/.test(password) === false) {
    rules.spCharacter = false;
    rules.valid = false;
  }

  if (password.length < 1 || password === compare) {
    rules.different = false;
    rules.valid = false;
  }

  return rules;
}

export default passwordStrengthRules;
